module.exports = {
  strings: {
    pluginNameFacebook: 'Facebook'
  }
};